import { render } from "./wForm.vue?vue&type=template&id=c4b088ce&ts=true"
import script from "./wForm.vue?vue&type=script&lang=ts"
export * from "./wForm.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__